// extracted by mini-css-extract-plugin
export default {"site-layout":"Sidenav_site-layout__tWIhi","site-layout-background":"Sidenav_site-layout-background__L9equ","menuLabel":"Sidenav_menuLabel__uOmtG"};